// extracted by mini-css-extract-plugin
module.exports = {"input":"editable-cell_input_kV9iU"};